<template>
<div class="pl-3" v-if="items.length > 0">
  <h6 class="italic py-3">{{ category.name }} ({{ items.length }})</h6>
            <ItemSearchProduct v-for="(item, index) in items"
                  :key="item.productId"
                  :product="item"
                  :category="category.id"
                  :is-active="isSameProduct(item, activeProduct)"
                  :is-selected="isSameProduct(item, selectedProduct)"
                  :full-width="fullWidth"
                  @product-selected="onSelected($event)" />
    </div>
</template>

<script setup lang="ts">
import ItemSearchProduct from './ItemSearchProduct.vue';

// Define emit events
const emit = defineEmits(['selected-pro']);

const props = defineProps({
  items: {
    type: Array,
    required: true,
  },
  category: {
    type: Object,
    required: true,
  },
  productCount: {
    type: Number,
    required: true
  },
  keyType: {
    type: String,
    required: true
  },
  /** Product currently highlighted via keyboard navigation. */
  activeProduct: {
    type: Object,
    default: null
  },
  /** Product currently selected by click. */
  selectedProduct: {
    type: Object,
    default: null
  },
  /** Stretch result rows to the container width instead of the fixed 442px. */
  fullWidth: {
    type: Boolean,
    default: false
  }
});

function isSameProduct(item, other) {
  if (!item || !other) return false;
  const itemId = item.productId ?? item.ProductId;
  const otherId = other.productId ?? other.ProductId;
  return itemId != null && itemId === otherId;
};

function onSelected(product) {
  
    emit('selected-pro', { product, type: props.keyType });
};

</script>

<style>
</style>